import xhrService from '../xhrService';
import {
  ReopenInspectionApi,
  SignatureGroupType,
} from '@stormwater-software/lib-certification';
import db from '../../db/db';
import { apiError } from '../apiError';
import { withOfflineWrite } from '../offlineFallback';

export const inspectionQuestionReopeningLogApi: ReopenInspectionApi = {
  update: async (inspectionId: number) => {
    // SW2-2321: was a `navigator.onLine` pre-check. Reopening after an offline
    // reload posted to the network, failed, and never applied the local change —
    // so the item stayed closed and the inspector's reopen was lost.
    return withOfflineWrite<any>(
      () =>
        xhrService
          .post(`/api/inspections/${inspectionId}/open`)
          .then((res) => res.data)
          .catch((err) => {
            throw apiError(err);
          }),
      async () => {
        const existingCertification = await db.certifications
          .get(inspectionId)
          .catch((error: any) => {
            console.log(
              'Error getting offline inspection certifications',
              error,
            );

            // SW2-2321: was a bare `Promise.reject(error)` — created but neither
            // returned nor awaited. The catch therefore resolved to `undefined`,
            // emitted an unhandled rejection, and the dereference below masked
            // the real cache error with a TypeError.
            // (Raised by Copilot on PR #53.)
            throw error;
          });

        if (!existingCertification) {
          throw new Error('Certification not cached offline');
        }

        existingCertification.userSignatures[SignatureGroupType.compliance] =
          [];
        existingCertification.sync.payload =
          existingCertification.sync.payload.filter(
            (item: any) => item.group !== 'compliance',
          );

        // Awaited: unawaited, this could resolve as a successful reopen while
        // either write was still pending, and a rejection would become an
        // unhandled promise. (Raised by Copilot on PR #53.)
        await db.inspections.update(inspectionId, { compliance_date: '' });
        await db.certifications.update(inspectionId, existingCertification);

        return db.inspections
          .get(inspectionId)
          .then((result) => {
            return { inspection: result };
          })
          .catch((err) => {
            throw apiError(err);
          });
      },
      // SW2-2321: `localOnlyWhenOffline` because nothing replays a reopen — the
      // sync loop handles only create/update payloads, and this path actually
      // *removes* the pending update payload. Resolving on an unreachable server
      // would report the inspection reopened while it stays closed on the server,
      // and the next download would overwrite the local state.
      // (Raised by Copilot on PR #53.)
      { localOnlyWhenOffline: true },
    );
  },
};

export default inspectionQuestionReopeningLogApi;
